import React from "react";

const Brand = (props) => 
	(<div className="navbar-header pull-left">
		<a href="#" className="navbar-brand">
			<big>
				Chart XL
			</big>
		</a>
	</div>);

export default Brand;



/** WEBPACK FOOTER **
 ** ./src/scripts/components/header/Brand.jsx
 **/